import(/* webpackMode: "eager" */ "/codebuild/output/src507617047/src/app/error.tsx");
